import Vue from 'vue'
import Router from 'vue-router'
import Calendar from "./components/Calendar";
import Piwi from "./components/Piwi";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Calendar',
      component: Calendar
    },
    {
      path: '/piwi',
      name: 'Piwi',
      component: Piwi
    },

  ]
})
